module.exports = __webpack_public_path__ + "static/media/icon-success-green.549cfefe.svg";